"use strict";

Shopify.theme.jsBrandPage = {
  init: async function init($section) {
    let dataCollections = [];
    const query = (nextCursor) => {
      return `
      {
        collections(first: 250, sortKey: TITLE ${nextCursor ? ', after: "' + nextCursor + '"' : ''}) {
          edges {
            node {
              id
              title
              onlineStoreUrl
              custom_link_for_brand:metafield(namespace: "brand", key: "custom_link_for_brand") {
                value
              }
              womens_brand:metafield(namespace: "brand", key: "womens_brand") {
                value
              }
              mens_brand:metafield(namespace: "brand", key: "mens_brand") {
                value
              }
              is_brand:metafield(namespace: "brand", key: "is_brand") {
                value
              }
              template:metafield(namespace: "collection", key: "template") {
                value
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
      `
    }
    // Add settings from schema to current object
    var apiUrl = "61522d162d1238a54e221bfa8fe30eb1"

    let data = await $.ajax({
      method: "POST",
      url: `https://${Shopify.shop}/api/2021-07/graphql.json`,
      contentType: "application/json",
      headers: {
        'X-Shopify-Storefront-Access-Token': `${apiUrl}`,
        'Content-Type': 'application/graphql'
      },
      data:             query(),
      });

      if(data) {
        dataCollections.push(...data.data.collections.edges);
      }

      if(data.data.collections.pageInfo.hasNextPage) {
        while(data.data.collections.pageInfo.hasNextPage) {
          data = await $.ajax({
            method: "POST",
            url: `https://${Shopify.shop}/api/2021-07/graphql.json`,
            contentType: "application/json",
            headers: {
              'X-Shopify-Storefront-Access-Token': `${apiUrl}`,
              'Content-Type': 'application/graphql'
            },
            data:             query(data.data.collections.pageInfo.endCursor),
            });

        dataCollections.push(...data.data.collections.edges);
        }
      }

      let brandCollections = [];
      dataCollections.forEach((item) => {
        if(item.node.template && item.node.template?.value == "brands") {
          brandCollections.push(item.node);
        }
      });

      let dataBrands = {};

      if(brandCollections.length > 0) {
        let alpha = [];
        let objects = [];
        brandCollections.forEach((item) => {
          const firstChar = item.title.toLowerCase()[0];
          if(!alpha.includes(firstChar)) {
            alpha.push(firstChar);
          }

          objects.push({
            name: item.title,
            custom_link: item.custom_link_for_brand?.value,
            link: item.onlineStoreUrl,
            letter: firstChar,
            women_category: item.womens_brand?.value,
            men_category: item.mens_brand?.value,
          });
        });

        Shopify.theme.jsBrandPage = $.extend(this, Shopify.theme.getSectionData($section), {alpha: alpha, brands: objects}); // Selectors

      }else {
        Shopify.theme.jsBrandPage = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors
      }

      const loader = document.querySelector('.brands__collections .loader-wrapper')

      loader && loader.classList.add('hide')


     this.activeLetters = [];
    this.activeGener = 'all';

       this.initTiny();
       this.initSlider();
  },

  initTiny: function initTiny() {
    var self = this;

    tinybind.bind($('.' + this.id), {
      data: this,
      methods: {
        hideActiveBrands: self.hideActiveBrands.bind(this),
        hideActiveBrandsByAlpha: self.hideActiveBrandsByAlpha.bind(this),
        scrollTo: self.scrollTo.bind(this),
      }
    });
  },

  hideActiveBrands: function hideActiveBrands(a) {

    this.activeLetters = [];

    var active =  a.target.getAttribute('data-gender');
    var brands = this.brands;

    this.activeGener = active;

    var elements = document.querySelectorAll('.brands__navigation-item');
    for (var i = 0; i < elements.length; i++) {
      elements[i].classList.remove('active');
    }

    a.target.classList.add('active');

    for(var i = 0 ; i < brands.length; i++) {
      if (active == 'all') {
        brands[i].disable = false;
      }
       else if (brands[i][active] != null) {
         brands[i].disable = false;
       }
       else  {
         brands[i].disable = true;
       }
    }
    this.hideLetter();
    this.clearActive();
  },

  hideActiveBrandsByAlpha: function hideActiveBrandsByAlpha(a) {


      var letter = a.target;
      var filterLetter = a.target.getAttribute('data-letter');
      letter.classList.toggle('active');


      if (!this.activeLetters.includes(filterLetter)) {
        this.activeLetters.push(filterLetter);
      } else {
        var index = this.activeLetters.indexOf(filterLetter);
        this.activeLetters.splice(index, 1);
      }

    if (this.activeGener == 'all') {
      if (this.activeLetters.length == 0) {
        for (var i = 0; i < this.brands.length; i++) {
          this.brands[i].disable = false;
        }
      } else {
        for (var i = 0; i < this.brands.length; i++) {
          if (this.activeLetters.includes(this.brands[i].letter)) {
            this.brands[i].disable = false;
          } else {
            this.brands[i].disable = true;
          }
        }
      }
    }
    else {
      this.hideActiveBrandsByAlphaAndCategory();
    }
  },
  hideActiveBrandsByAlphaAndCategory: function hideActiveBrandsByAlphaAndCategory() {

    if (this.activeLetters.length == 0) {
      for (var i = 0; i < this.brands.length; i++) {
        if (this.brands[i][this.activeGener] != null) {
        this.brands[i].disable = false;
        }
      }
    } else {
      for (var i = 0; i < this.brands.length; i++) {
        if (this.activeLetters.includes(this.brands[i].letter) && this.brands[i][this.activeGener] != null) {
          this.brands[i].disable = false;
        } else {
          this.brands[i].disable = true;
        }
      }
    }

  },

  scrollTo: function scrollTo(a) {
    a.preventDefault();
    var letter = a.target;
    var id = letter.getAttribute("data-letter");
    var headerHeight =  $('.header-section').height() + $('.header__second-menu').height();
    $("html, body").animate({ scrollTop: $(id).offset().top - headerHeight}, 1000);
  },

  clearActive: function clearActive() {
    var elements = document.querySelectorAll('.brands__letter');
    for (var i = 0; i < elements.length; i++) {
      elements[i].classList.remove('active');
    }
  },

  hideLetter: function hideLetter() {
    let displayItems = this.brands.filter(item => item.disable !== true);
    let newAlpha = displayItems.map(item => item.letter);
    this.alpha = [...new Set(newAlpha)];

  },
  initSlider: function initSlider() {

    var selector = $('.brands__slider');
    // var mobile =  ($(window).width() > 798);

    // if (data.products.length > 4 &&  mobile || data.products.length > 2 && !mobile) {

      var slider = selector.flickity({
        prevNextButtons:  true,
        freeScroll: true,
        pageDots: false,
        contain: true,
        draggable: true,
        cellAlign: 'left'
      });

      setTimeout(function () {
        slider.flickity('resize');
      },500);

      theme.utils.fixFlikityPrevNextButton(slider, '.brands__slider');
  }
};